import Vue from 'vue'

// defino variables y funciones globales
export default Vue.mixin({
    methods: {
        parseGQLErrors (error) {
            let { graphQLErrors } = error;
            let errorMessage = graphQLErrors[0].message 
            this.$toast.error(errorMessage)
            return errorMessage
        },
        parseErrors(errors){ 
            let parsedErrors = {
                validation:{},
                messages:{},
            };
            Object.keys(errors).forEach( (key) => {
                let label = key.replace("data.", "")
                parsedErrors.validation[label] = false;
                parsedErrors.messages[label] = errors[key][0].replace("data.", "");
                
            });
            return parsedErrors;
        },
        checkValidation() {
			return this.$validate()
			.then(function (success) {
				if (success) {
					return true
				}
				return false
			});
		},
    }
})
